import { ContentState, convertToRaw } from 'draft-js';

import { removeAdditionalBySchema } from './schema';

export default function exportContent(blocks) {
  const rawBlocks = blocks.map(exportBlock);
  return removeAdditionalBySchema(rawBlocks);
}

export function exportBlock(block) {
  return block.map(field => (field instanceof ContentState ? convertToRaw(field) : field));
}
